import { render, staticRenderFns } from "./RvsDetail.vue?vue&type=template&id=785157be&scoped=true"
import script from "./RvsDetail.vue?vue&type=script&lang=ts"
export * from "./RvsDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785157be",
  null
  
)

export default component.exports